import React from "react"
import {Icon} from "components/Icon"
import styles from "./SAPCheckPoints.module.css"
import {useModel} from "hooks"

type SAPCheckPointsProps = {
    profileId: number
}

export function SAPCheckPoints(props: SAPCheckPointsProps) {
    const {profileId} = props
    const model = useModel()

    const isShowIcon = !!(model.slug === "demo" && profileId === 8990)

    return (
        <div className={styles.wrap}>
            <div className={styles.header}>
                {isShowIcon && <Icon icon="FILE_LINE_ALT" color="#62B1FF" />}
                <p className={styles.headerTitle}>SAP Checkpoints</p>
            </div>
            <div className={styles.body}>
                <div className={styles.item}>
                    <p className={styles.itemTitle}>Good Standing (Overall)</p>
                    {isShowIcon && (
                        <Icon
                            className={styles.warningIcon}
                            color="var(--warning-400-base)"
                            icon={"WARNING_TRIANGLE_FILL"}
                        />
                    )}
                </div>
                <div className={styles.item}>
                    <p className={styles.itemTitle}>Academic Standing</p>
                    {isShowIcon && <Icon className={styles.warningIcon} color="#18A957" icon={"ATTENDANCE_IN"} />}
                </div>
                <div className={styles.item}>
                    <p className={styles.itemTitle}>Program Completion</p>
                    {isShowIcon && (
                        <Icon
                            className={styles.warningIcon}
                            color="var(--warning-400-base)"
                            icon={"WARNING_TRIANGLE_FILL"}
                        />
                    )}
                </div>
                <div className={styles.item}>
                    <p className={styles.itemTitle}>Completion Rate of Attempted Units</p>
                    {isShowIcon && <Icon className={styles.warningIcon} icon={"CROSS_CIRCLE"} color="#df1642" />}
                </div>
                <div className={styles.item}>
                    <p className={styles.itemTitle}>Cumulative GPA</p>
                    {isShowIcon && <Icon className={styles.warningIcon} color="#18A957" icon={"ATTENDANCE_IN"} />}
                </div>
                <div className={styles.item}>
                    <p className={styles.itemTitle}>Graduation Requirements</p>
                    {isShowIcon && <Icon className={styles.warningIcon} color="#18A957" icon={"ATTENDANCE_IN"} />}
                </div>
                <p className={styles.note}>
                    If you see one or more{" "}
                    <Icon
                        className={styles.warningIcon}
                        color="var(--warning-400-base)"
                        icon={"WARNING_TRIANGLE_FILL"}
                    />{" "}
                    or <Icon className={styles.warningIcon} icon={"CROSS_CIRCLE"} color="#df1642" />, please schedule an
                    appointment with your Advisor immediately.
                </p>
            </div>
        </div>
    )
}
